// extracted by mini-css-extract-plugin
export default {"loginForm":"PasswordLogin_loginForm__EtcMT","resetPasswordButton":"PasswordLogin_resetPasswordButton__UufMi","marginRight":"PasswordLogin_marginRight__cU5fE"};